import logo from "../assets/optimized/PBSLogo.webp";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Button from "./ui/button";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <AnimatePresence>
      {scrolled && (
        <motion.header
          initial={{ y: -80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -80, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="fixed top-0 w-full z-50 bg-[#5D2F02]/90 shadow-md border-b border-accentyellow"
        >
          <div className="flex flex-wrap items-center justify-between px-4 py-3 max-w-7xl mx-auto">
            {/* Logo */}
            <div className="flex items-center space-x-2">
              <img
                onClick={() => navigate("/")}
                src={logo}
                alt="PBS Logo"
                className="w-16 h-auto"
              />
              <span className="text-2xl font-bold text-accentyellow">PBS</span>
            </div>

            {/* Hamburger Button */}
            <button
              className="md:hidden text-accentyellow"
              onClick={toggleMenu}
              aria-label="Toggle Menu"
            >
              {menuOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex flex-wrap text-lg items-center space-x-4 text-accentyellow">
              <Link
                to="/coaching"
                className="hover:underline hover:text-[#388B91]"
              >
                All things Coaching
              </Link>
              <Link
                to="/about"
                className="hover:underline hover:text-[#388B91]"
              >
                About Us
              </Link>
              <a
                onClick={() =>
                  navigate("/services", { state: { background: location } })
                }
                className="hover:underline hover:text-[#388B91]"
              >
                Services
              </a>
              <Link
                to="/retreats"
                className="hover:underline hover:text-[#388B91]"
              >
                Retreats & Conferences
              </Link>
              <Link
                to="/testimonials"
                className="hover:underline hover:text-[#388B91]"
              >
                Testomonials
              </Link>
              <Link
                to="/bookings"
                className="hover:underline hover:text-[#388B91]"
              >
                Book a Session
              </Link>
              <Button onClick={() => navigate("/contact")} variant="outline">
                Schedule with us
              </Button>
            </nav>
          </div>

          {/* Mobile Menu */}
          {menuOpen && (
            <div className="md:hidden bg-[#5D2F02] bg-opacity-95 px-4 pb-4 space-y-4 text-accentyellow text-center">
              <Link
                to="/coaching"
                className="block hover:underline hover:text-[#388B91]"
              >
                Life Coaching
              </Link>
              <Link
                to="/about"
                className="block hover:underline hover:text-[#388B91]"
              >
                About Us
              </Link>
              <Link
                to="/retreats"
                className="hover:underline hover:text-[#388B91]"
              >
                Retreats & Conferences
              </Link>
              <Link
                to="/testimonials"
                className="hover:underline hover:text-[#388B91]"
              >
                Testomonials
              </Link>
              <a
                onClick={() =>
                  navigate("/services", { state: { background: location } })
                }
                className="block hover:underline hover:text-[#388B91]"
              >
                Services
              </a>
              <div className="pt-2">
                <Button
                  variant="outline"
                  onClick={() => navigate("/contact")}
                  className="w-full"
                >
                  Schedule an appointment now
                </Button>
              </div>
            </div>
          )}
        </motion.header>
      )}
    </AnimatePresence>
  );
}
